import { Flex, VStack } from "@chakra-ui/react";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "./Footer";
import { Header } from "./Header";

const Layout = () => {
  const location = useLocation();

  const isOrderFlowPage =
    location.pathname === "/cart" ||
    location.pathname === "/cart/" ||
    location.pathname === "/transaction" ||
    location.pathname === "/transaction/" ||
    location.pathname === "/payment" ||
    location.pathname === "/payment/";

  return (
    <VStack
      className="root-layout-landing"
      w={"100%"}
      minH={"100dvh"}
    >
      <Header />
      <Flex
        flexDir={"column"}
        mx={"auto"}
        w={"full"}
        maxW={{ base: "100%", "2xl": "1460px" }}
        flex={1}
        overflowX={"hidden"}
      >
        <Outlet />
      </Flex>
      {!isOrderFlowPage && <Footer />}
    </VStack>
  );
};

export default Layout;
